import React from "react";
import { Loader2, MessageSquarePlus } from "lucide-react";

export default function ManagersTab({ managers, draftPitch }) {
  if (managers === null) {
    return (
      <div className="card-bordered p-12 flex flex-col items-center gap-3">
        <Loader2 className="w-6 h-6 spin text-[var(--accent)]" />
        <div className="text-sm text-[var(--text-3)]">Scanning this season's trade history…</div>
      </div>
    );
  }
  if ((managers.managers || []).length === 0) {
    return <div className="card-bordered p-8 text-center text-sm text-[var(--text-3)]">No trade history found for this league yet.</div>;
  }
  return (
    <>
      <div className="text-sm text-[var(--text-2)] mb-3">{managers.total_trades} trades analyzed this season. Know who you're dealing with before you offer.</div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {managers.managers.map(m => (
          <div key={m.roster_id} className="card-bordered p-5" data-testid={`manager-${m.roster_id}`}>
            <div className="flex items-center justify-between mb-2">
              <div className="font-display font-bold text-lg">{m.manager}</div>
              <div className="font-mono text-xs text-[var(--text-3)]">{m.trades} TRADES</div>
            </div>
            <div className="flex flex-wrap gap-1.5 mb-3">
              {m.tags.map((t, i) => (
                <span key={i} className="text-[10px] tracking-wider uppercase px-2 py-0.5 rounded-sm border border-[var(--border)] text-[var(--text-2)] bg-black/40">{t}</span>
              ))}
            </div>
            <p className="text-sm text-[var(--text-2)] italic mb-3">{m.persona}</p>
            <div className="grid grid-cols-3 gap-2 text-center border-t border-b border-[var(--border)] py-3 mb-3">
              <div><div className="font-mono text-sm text-[var(--accent)]">{m.pick_affinity_pct}%</div><div className="text-[9px] tracking-widest text-[var(--text-3)]">PICK TRADES</div></div>
              <div><div className="font-mono text-sm">{m.fav_position || "—"}</div><div className="text-[9px] tracking-widest text-[var(--text-3)]">ACQUIRES</div></div>
              <div><div className="font-mono text-sm">{m.avg_acquired_age || "—"}</div><div className="text-[9px] tracking-widest text-[var(--text-3)]">AVG AGE</div></div>
            </div>
            <button onClick={() => draftPitch(m)} className="btn-primary w-full text-xs inline-flex items-center justify-center gap-2" data-testid={`pitch-btn-${m.roster_id}`}>
              <MessageSquarePlus className="w-3.5 h-3.5" /> Draft AI trade pitch
            </button>
          </div>
        ))}
      </div>
    </>
  );
}
